import React from 'react';
import OperatorRequestBase from './OperatorRequestBase';
import InformesMensualesForm from '../../components/requests/InformesMensualesForm';
import { useAuth } from '../../context/AuthContext';

const OperatorModelosImpuestos = () => {
  const { isGlobalAdmin } = useAuth();
  const basePath = isGlobalAdmin() ? '/global-admin' : '/operator';

  return (
    <OperatorRequestBase
      title="Informes Mensuales"
      description="Genera balance y libro diario del periodo para el cliente."
      requestType="informes_mensuales"
      FormComponent={InformesMensualesForm}
      backHref={`${basePath}/workspace`}
    />
  );
};

export default OperatorModelosImpuestos;
